import { AttachmentUploadGuard } from './attachment-upload-guard.service';
import { AuthGuard } from './auth-guard.service';

export const COMMON_GUARD_SERVICES = [AuthGuard, AttachmentUploadGuard];
